import AuthMiddleware from "@/middleware/auth";
const allSendOuts = () =>
  import(/* webpackChunkName: "sendouts" */ "@/views/sendOuts/AllSendOuts.vue");
const ActiveSendOuts = () =>
  import(
    /* webpackChunkName: "sendouts" */ "@/views/sendOuts/ActiveSendOuts.vue"
  );
const CompleteSendOuts = () =>
  import(
    /* webpackChunkName: "sendouts" */ "@/views/sendOuts/CompleteSendOuts.vue"
  );
const SendOutsInformation = () =>
  import(
    /* webpackChunkName: "sendouts" */ "@/components/sendOuts/SendOutsInformation"
  );
const SendOutsRouter = [
  {
    path: "/all-send-outs",
    name: "allSendOuts",
    component: allSendOuts,
    beforeEnter: AuthMiddleware.user,
    meta: {
      title: "SEND OUTS",
    },
  },
  {
    path: "/all-send-outs/active",
    name: "ActiveSendOuts",
    component: ActiveSendOuts,
    beforeEnter: AuthMiddleware.user,
    meta: {
      title: "SEND OUTS",
    },
  },
  {
    path: "/all-send-outs/finalized",
    name: "CompleteSendOuts",
    component: CompleteSendOuts,
    beforeEnter: AuthMiddleware.user,
    meta: {
      title: "SEND OUTS",
    },
  },
  {
    path: "/send-outs/:sendout_id",
    name: "SendoutsInformation",
    component: SendOutsInformation,
    beforeEnter: AuthMiddleware.user,
    meta: {
      title: "SEND OUTS",
    },
  },
];

export { SendOutsRouter };
